import { useState } from 'react';
import type { FaqItem } from '@/mocks/content';

interface FaqAccordionProps {
  items: FaqItem[];
  defaultOpenId?: number;
}

export default function FaqAccordion({ items, defaultOpenId }: FaqAccordionProps) {
  const [openId, setOpenId] = useState<number | null>(defaultOpenId ?? null);

  return (
    <div className="divide-y divide-background-200 border-y border-background-200">
      {items.map((item) => {
        const open = openId === item.id;
        return (
          <div key={item.id}>
            <h3>
              <button
                type="button"
                onClick={() => setOpenId(open ? null : item.id)}
                aria-expanded={open}
                className="flex w-full cursor-pointer items-center justify-between gap-4 py-5 text-left"
              >
                <span className="flex items-start gap-3">
                  <span className="mt-0.5 shrink-0 bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900">
                    {item.category}
                  </span>
                  <span className="font-heading text-base font-bold text-foreground-950">
                    {item.question}
                  </span>
                </span>
                <i
                  className={
                    open
                      ? 'ri-subtract-line shrink-0 text-lg text-primary-600'
                      : 'ri-add-line shrink-0 text-lg text-foreground-500'
                  }
                  aria-hidden="true"
                />
              </button>
            </h3>
            {open && (
              <div className="pb-5 pl-0 md:pl-24">
                <p className="text-sm leading-relaxed text-foreground-600">{item.answer}</p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}